// Reflections Holidays booking strategy.
//
// A site's reserveUrl is the category's own page on reflectionsholidays.com.au
// (/parks/{park}/accommodation/{category}/). The page takes the stay and the
// party in its query string (`from`, `to` as YYYY-MM-DD, `adults`) and opens
// with them filled in and the price quoted, one Book now away from the
// cart. A stay that breaks the park's rules (summer Saturday-to-Saturday
// blocks) renders the park's own message instead.

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

const isoDate = (date) => format(date, "yyyy-MM-dd");

// The booking panel's own default party.
const DEFAULT_ADULTS = 2;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate, partySize } = ctx;
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.searchParams.set("from", isoDate(arrivalDate));
    url.searchParams.set("to", isoDate(resolveCheckout(ctx)));
    url.searchParams.set("adults", String(partySize ?? DEFAULT_ADULTS));
    return url.toString();
  },

  // The park's accommodation list, every category it sells, is the
  // facility overview; the reserveUrl is one category's page.
  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.pathname = url.pathname.replace(
      /\/accommodation\/[^/]+\/?$/,
      "/accommodation/",
    );
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as ?from=<yyyy-MM-dd>.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &to=<yyyy-MM-dd>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already is the category's page.",
        },
        partySize: {
          status: "defaulted",
          defaultValue: DEFAULT_ADULTS,
          notes: "Encoded as &adults=<N>; the booking panel's default is 2.",
        },
      },
    };
  },
};
